import React from 'react'
import Box from '@mui/material/Box'

import FilmIcon from '@/components/ui/icons/Film'

interface NoRemoteVideoProps { }

export function NoRemoteVideo(props: NoRemoteVideoProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'background.idle' }}>
      <FilmIcon />
    </Box>
  )
}

export default NoRemoteVideo